
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestbabyformulalawyers/contact-us",
      function () {
        return require("private-next-pages/bestbabyformulalawyers/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestbabyformulalawyers/contact-us"])
      });
    }
  